(() => {
  const pilotSelector =
    'product-info.tc-protection-disc-pilot, product-info.tc-simple-protection-pilot, product-info.tc-upgrade-kit-pilot, product-info.tc-upgrade-kit-fallback, product-info.tc-bumper-pilot';
  const productProtectedSelector = [
    'variant-selects .product-form__input',
    '.product-form__quantity',
    '.tc-protection-disc-summary',
    '.tc-simple-protection-summary',
    '.tc-upgrade-kit-summary',
    '.tc-bumper-summary',
    '.product-form__buttons',
    '.tc-protection-disc-details',
    '.tc-simple-protection-details',
    '.tc-upgrade-kit-details',
    '.tc-upgrade-kit-editorial',
    '.tc-bumper-details',
  ].join(', ');
  const externalProtectedSelector = [
    '#judgeme_product_reviews button',
    '#judgeme_product_reviews a[href]',
    '#judgeme_product_reviews select',
    '#judgeme_product_reviews input:not([type="hidden"])',
    '#judgeme_product_reviews textarea',
    '#judgeme_product_reviews summary',
    '#judgeme_product_reviews [role="button"]',
    '#judgeme_product_reviews [role="link"]',
    '#judgeme_product_reviews [tabindex]:not([tabindex="-1"])',
  ].join(', ');
  const mobileQuery = window.matchMedia('(max-width: 619.98px)');
  const productInfo = document.querySelector(pilotSelector);

  if (!productInfo) return;

  document.documentElement.classList.add('tc-pilot-chat-guard-enabled');

  let chat = null;
  let frame = null;
  let resizeObserver = null;
  let stabilizationTimer = null;

  const isRendered = (element) => {
    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();

    return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
  };

  const rectanglesIntersect = (first, second) =>
    first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;

  const getProtectedElements = () => [
    ...productInfo.querySelectorAll(productProtectedSelector),
    ...document.querySelectorAll(externalProtectedSelector),
  ];

  const clearGuard = () => {
    if (!chat) return;

    chat.removeAttribute('data-tc-pilot-overlap');
  };

  const updateGuard = () => {
    frame = null;

    if (!chat || !mobileQuery.matches) {
      clearGuard();
      return;
    }

    const chatRect = chat.getBoundingClientRect();

    if (chatRect.width === 0 || chatRect.height === 0) {
      clearGuard();
      return;
    }

    const chatHasFocus = chat.matches(':focus-within') || document.activeElement === chat;
    const chatIsClosed = chat.getAttribute('is-open') === 'false';

    if (chatHasFocus || !chatIsClosed) {
      clearGuard();
      return;
    }

    const overlapsProtectedContent = getProtectedElements()
      .filter(isRendered)
      .some((element) => rectanglesIntersect(chatRect, element.getBoundingClientRect()));

    chat.toggleAttribute('data-tc-pilot-overlap', overlapsProtectedContent);
  };

  const scheduleGuard = () => {
    if (frame !== null) return;
    frame = window.requestAnimationFrame(updateGuard);
  };

  const startStabilizationChecks = () => {
    window.clearTimeout(stabilizationTimer);

    let remainingChecks = 40;
    const check = () => {
      scheduleGuard();
      remainingChecks -= 1;

      if (remainingChecks > 0) stabilizationTimer = window.setTimeout(check, 250);
    };

    check();
  };

  const observeChat = (element) => {
    if (chat === element) return;

    clearGuard();
    resizeObserver?.disconnect();
    chat = element;
    resizeObserver = new ResizeObserver(scheduleGuard);
    resizeObserver.observe(chat);
    resizeObserver.observe(productInfo);
    resizeObserver.observe(document.body);
    getProtectedElements().forEach((protectedElement) => resizeObserver.observe(protectedElement));
    startStabilizationChecks();
  };

  const findChat = () => {
    const currentChat = document.querySelector('#ShopifyChat');

    if (currentChat) {
      observeChat(currentChat);
    } else if (chat) {
      clearGuard();
      resizeObserver?.disconnect();
      window.clearTimeout(stabilizationTimer);
      chat = null;
      stabilizationTimer = null;
    }

    scheduleGuard();
  };

  window.addEventListener('scroll', scheduleGuard, { passive: true });
  window.addEventListener('resize', scheduleGuard, { passive: true });
  window.addEventListener('load', scheduleGuard);
  document.addEventListener('focusin', scheduleGuard);
  document.addEventListener('focusout', scheduleGuard);
  mobileQuery.addEventListener('change', scheduleGuard);

  const chatObserver = new MutationObserver(findChat);
  chatObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['is-open'],
    childList: true,
    subtree: true,
  });
  findChat();
})();
